import type { ComponentPropsWithRef } from 'react'

import { cn } from '../../../_lib/utils'

const Subtitle = ({ children, className }: ComponentPropsWithRef<'h2'>) => {
  return (
    <h2 className={cn('text-xs font-bold text-brand-green-primary-5', className)}>{children}</h2>
  )
}

const Title = ({ children, className }: ComponentPropsWithRef<'h1'>) => {
  return <h1 className={cn('text-2xl font-bold text-brand-grayscale-12', className)}>{children}</h1>
}

const Text = ({ children, className }: ComponentPropsWithRef<'p'>) => {
  return <p className={cn('text-sm font-semibold text-brand-grayscale-7', className)}>{children}</p>
}
export { Subtitle, Text, Title }
